import classNames from "classnames";
import {PropsWithChildren} from "react";
import {IconType} from "react-icons";

import {Icon} from "@/components/icon/Icon.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";

import styles from "./FormLabel.module.scss";

export type FormLabelTypography = "bodySmallBold" | "bodySmallMedium" | "bodySmall";

interface IFormLabelProps extends PropsWithChildren {
  forId: string; // make sure we care about accessibility
  className?: string;
  helpText?: string;
  required?: boolean;
  icon?: IconType;
  hasRequiredLabel?: boolean;
  labelTypography?: FormLabelTypography;
  description?: string;
}

export const FormLabel = ({
  forId,
  className,
  helpText,
  required,
  icon,
  children,
  hasRequiredLabel = false,
  labelTypography = "bodySmallBold",
  description,
}: IFormLabelProps) => (
  <label
    htmlFor={forId}
    className={classNames(styles.formLabel, styles[labelTypography], {[styles.required]: required}, className)}
  >
    <div>
      {icon && <Icon display={"inline"} removeDivDimensions icon={icon} className="me-2" />}
      {children}
      {required && <span className="ms-1 text-danger">*</span>}
      {helpText && (
        <TooltipIconRA
          className={classNames("ms-2", styles.tooltip)}
          title={helpText}
          iconProps={{
            display: "inline",
            removeDivDimensions: true,
          }}
        />
      )}
      {required && hasRequiredLabel && (
        <span className="float-end">
          <span className="ms-1 text-danger">*</span> Required
        </span>
      )}
    </div>
    {description && <p className={styles.description}>{description}</p>}
  </label>
);
